class MagnificPopup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: this.props.visible || false,
      content: this.props.content || null,
      size: this.props.size || null,
      hideClose: this.props.hideClose || false
    }
    this.handleWindowMessageWrapper = this.handleWindowMessage.bind(this)
  }

  componentDidMount() {
    window.reactMagnificPopup = this
    window.addEventListener('message', this.handleWindowMessageWrapper)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleWindowMessageWrapper)
  }

  UNSAFE_componentWillUpdate() {}

  componentDidUpdate(prevProps, prevState) {}

  closePopup(e) {
    if (e) e.preventDefault()
    this.setState({ visible: false })
  }

  handleWindowMessage(e) {
    if (!e.data || !e.data.type) return
    switch (e.data.type) {
      case 'close_magnific_popup':
        this.closePopup()
        break
      default:
        return
    }
  }

  render() {
    if (this.state.visible) {
      return (
        <React.Fragment>
          <div className="mfp-bg mfp-ready"></div>
          <div
            className="mfp-wrap mfp-close-btn-in mfp-align-top mfp-auto-cursor mfp-ready"
            tabIndex="-1"
            style={{ overflow: 'hidden auto' }}
          >
            <div className="mfp-container mfp-ajax-holder mfp-s-ready">
              <div className="mfp-content">
                <div className={classNames('white-popup-block', this.state.size)}>
                  {this.state.content}
                  {!this.state.hideClose ? (
                    <button type="button" className="mfp-close large" onClick={this.closePopup.bind(this)}>
                      <i className="fal fa-times"></i>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }
}

export default MagnificPopup
